import { FunctionComponent } from 'react';
import { ColumnHeaderFilterIconButtonProps, GridFilterAltIcon } from '@mui/x-data-grid-pro';

export const ColumnHeaderFilterIcon: FunctionComponent<ColumnHeaderFilterIconButtonProps> = ({ counter }) => {
  if (counter > 0) {
    return (
      <GridFilterAltIcon color={'action'} />
    );
  }

  return null;
};
